// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_img__wg7kC {
  position: relative;
}

.styles_default__C64sY {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.styles_default__C64sY img {
  height: auto;
}

.styles_basic__M0jCt {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.styles_carousel__7DaCY {
  width: 100%;
  aspect-ratio: 16/9;
}
.styles_carousel__7DaCY img {
  aspect-ratio: 16/9;
  width: 100%;
  height: auto;
  max-height: 100vh;
  -o-object-fit: contain;
  object-fit: fill;
  display: block;
  -o-object-position: bottom;
     object-position: bottom;
}

.styles_imgMax__Y3T-h {
  width: 100%;
  height: 100%;
  display: flex;
}
.styles_imgMax__Y3T-h img {
  height: 100%;
  width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}

.styles_imgSmall__iTgh- {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.styles_imgSmall__iTgh- img {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./../../shared/src/componets/ui/Img/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AACJ;AACI;EACI,YAAA;AACR;;AAIA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;AADJ;;AAIA;EACI,WAAA;EACA,kBAAA;AADJ;AAGI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;KAAA,uBAAA;AADR;;AAKA;EACI,WAAA;EACA,YAAA;EACA,aAAA;AAFJ;AAII;EACI,YAAA;EACA,WAAA;EACA,sBAAA;KAAA,mBAAA;AAFR;;AAMA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAKI;EACI,WAAA;EACA,YAAA;AAHR","sourcesContent":[".img{\n    position: relative;\n}\n\n.default {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n\n    img {\n        height: auto;\n    }\n}\n\n\n.basic {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n}\n\n.carousel {\n    width: 100%;\n    aspect-ratio: 16 / 9;\n\n    img {\n        aspect-ratio: 16 / 9;\n        width: 100%;\n        height: auto;\n        max-height: 100vh;\n        -o-object-fit: contain;\n        object-fit: fill;\n        display: block;\n        object-position: bottom;\n    }\n}\n\n.imgMax {\n    width: 100%;\n    height: 100%;\n    display: flex;\n\n    img {\n        height: 100%;\n        width: 100%;\n        object-fit: contain;\n    }\n}\n\n.imgSmall {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    overflow: hidden;\n\n    img {\n        width: 100%;\n        height: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": `styles_img__wg7kC`,
	"default": `styles_default__C64sY`,
	"basic": `styles_basic__M0jCt`,
	"carousel": `styles_carousel__7DaCY`,
	"imgMax": `styles_imgMax__Y3T-h`,
	"imgSmall": `styles_imgSmall__iTgh-`
};
export default ___CSS_LOADER_EXPORT___;
